export class FetchTerminalAction {
  static readonly type = '[Terminal] Fetch Terminals';
}
